/* Confetti burst for the free-gift unlock. Exposes window.krfConfetti().
   No-ops under prefers-reduced-motion. */
(function () {
  if (window.krfConfetti) return;

  var COLORS = ['#004720', '#FFED00', '#186e3f', '#ffffff', '#8bc34a'];

  window.krfConfetti = function () {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var canvas = document.createElement('canvas');
    document.body.appendChild(canvas);

    /* The cart drawer is a <dialog> opened with showModal(), which puts it in the
       browser's top layer -- no z-index can paint over it. A popover joins that
       same layer, and top-layer elements paint in promotion order, so showing one
       after the drawer opened puts the burst in front.

       Detects NATIVE support specifically: the theme ships popover-polyfill.js,
       whose popovers are ordinary elements and would not beat the dialog. Without
       it we fall back to a plain fixed canvas. */
    var nativePopover = false;
    try {
      nativePopover =
        typeof canvas.showPopover === 'function' &&
        typeof CSS !== 'undefined' &&
        CSS.supports &&
        CSS.supports('selector(:popover-open)');
    } catch (e) {
      nativePopover = false;
    }

    if (nativePopover) {
      canvas.setAttribute('popover', 'manual');
      try {
        canvas.showPopover();
      } catch (e) {
        /* UA style for [popover] is display:none, so a failed show must not leave
           the attribute behind or the canvas is invisible. */
        canvas.removeAttribute('popover');
      }
    }

    /* Set last and with priority: beats the UA [popover] rules and any inline
       styles the polyfill may have written. */
    var css = {
      position: 'fixed',
      inset: '0',
      margin: '0',
      padding: '0',
      border: '0',
      background: 'transparent',
      width: '100%',
      height: '100%',
      'max-width': '100%',
      'max-height': '100%',
      overflow: 'hidden',
      'pointer-events': 'none',
      'z-index': '2147483000'
    };
    for (var prop in css) {
      if (Object.prototype.hasOwnProperty.call(css, prop)) {
        canvas.style.setProperty(prop, css[prop], 'important');
      }
    }

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = window.innerWidth * dpr;
    canvas.height = window.innerHeight * dpr;
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    var W = window.innerWidth;
    var H = window.innerHeight;
    var pieces = [];

    for (var i = 0; i < 110; i++) {
      pieces.push({
        x: W / 2 + (Math.random() - 0.5) * W * 0.5,
        y: H * 0.32 + (Math.random() - 0.5) * 60,
        vx: (Math.random() - 0.5) * 9,
        vy: Math.random() * -9 - 3,
        w: 6 + Math.random() * 6,
        h: 8 + Math.random() * 8,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        color: COLORS[(Math.random() * COLORS.length) | 0]
      });
    }

    /* A modal opened after us would paint back over the burst, and the drawer
       auto-opens on add. Re-showing re-promotes to the top of the stack. */
    function rePromote() {
      if (!canvas.isConnected || !canvas.hasAttribute('popover')) return;
      try {
        canvas.hidePopover();
        canvas.showPopover();
      } catch (e) {}
    }

    if (nativePopover) {
      document.addEventListener('cart-drawer:open', rePromote);
      setTimeout(rePromote, 250);
      setTimeout(rePromote, 600);
    }

    var start = performance.now();

    function frame(now) {
      var elapsed = now - start;
      ctx.clearRect(0, 0, W, H);

      for (var i = 0; i < pieces.length; i++) {
        var p = pieces[i];
        p.vy += 0.28;          // gravity
        p.vx *= 0.995;         // drag
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;

        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - elapsed / 2600);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }

      if (elapsed < 2600) {
        requestAnimationFrame(frame);
      } else {
        /* Removing an open popover implicitly hides it; the try/catch is only
           for engines that throw when hidePopover() runs on a detached node. */
        document.removeEventListener('cart-drawer:open', rePromote);
        try {
          if (canvas.hasAttribute('popover')) canvas.hidePopover();
        } catch (e) {}
        canvas.remove();
      }
    }

    requestAnimationFrame(frame);
  };
})();
